var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('generic-container',{attrs:{"title":_vm.$t('active support plans'),"icon":"file contract"}},[_vm._v("aaa")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }